import Base from '@studiometa/js-toolkit/abstracts/Base';
import nextFrame from '@studiometa/js-toolkit/utils/nextFrame';
import axios from 'axios';
import Choices from 'choices.js';
import Cache from '../utils/cache.js';
import { isDev } from '../config.js';

const cache = new Cache({ name: 'filters' });

/**
 * Filters component
 */
export default class Filters extends Base {
  /**
   * Component Configuration
   */
  get config() {
    return {
      name: 'Filters',
      ajaxUrl: '/wp/wp-admin/admin-ajax.php',
      log: isDev(),
    };
  }

  /**
   * Mounted hook
   */
  mounted() {
    this.query();
  }

  /**
   * open Panel (mobile)
   */
  onOpenPanelClick() {
    this.$el.classList.add('is-open');
  }

  /**
   * open Panel (mobile)
   */
  onClosePanelClick() {
    this.$el.classList.remove('is-open');
  }

  /**
   * select ref change
   */
  onSelectChange() {
    this.query();
  }

  /**
   * On page click
   */
  onPageClick(event, index) {
    window.scroll(0, 0);

    event.preventDefault();
    const { paged } = this.$refs.page[index].dataset;
    this.query(paged);
  }

  /**
   * get results
   */
  query(paged = 1) {
    this.$el.classList.add('is-loading');

    // Add all the query params to the request
    const params = new URLSearchParams();
    params.append('action', 'get_products');
    params.append('paged', paged);

    this.$refs.select.forEach((select) => {
      params.append(select.name, select.value);
    });

    // Load and return front end cache if it exist.
    const filterCache = cache.get(params);

    if (filterCache) {
      this.updateContent(filterCache);
      return;
    }

    axios
      .post(this.config.ajaxUrl, params)
      .then(({ data }) => {
        cache.set(params, data.data);
        this.updateContent(data.data);
      })
      .catch((error) => {
        this.$log(error, params);
      });
  }

  /**
   * Update Content
   * @param {string} results to insert in the template.
   * @param {string} filters to insert in the template.
   */
  async updateContent({ results, filters }) {
    this.$refs.results.innerHTML = results;
    this.$refs.filters.innerHTML = filters;
    this.$el.classList.remove('is-loading');
    this.$update();

    this.$refs.select.forEach((select) => {
      // eslint-disable-next-line
      new Choices(select, {
        searchEnabled: false,
        itemSelectText: '✓',
      });
    });

    await nextFrame();
    await nextFrame();

    // Attach card links to Highway JS
    this.$parent.highway.attach(document.querySelectorAll('.product-link'));
  }
}
